import React, { useEffect, useState } from "react";
import { Box } from "@components/Box/Box";
import { Heading } from "@components/Heading/Heading";
import { Text } from "@components/Text/Text";
import { Module } from "@components/Module/Module";
import { Container } from "@components/Container/Container";
import styles from "./styles.module.scss";

export interface EmbedProps {
  EmbedCode: string;
  Use800PxRibbon: boolean;
  NoCookieHeading: string;
  NoCookieText: string;
}

const Embed: React.FC<EmbedProps> = ({
  EmbedCode,
  Use800PxRibbon,
  NoCookieHeading,
  NoCookieText
}) => {
  const [cookieState, setCookieState] = useState<boolean>(true); // set to false before deploying to prod
  
  /* UNCOMMENT this before deploying to prod
  useEffect(() => {
    if (globalThis.CookieInformation) {
      if (
        globalThis.CookieInformation.getConsentGivenFor(
          "cookie_cat_marketing"
        ) &&
        globalThis.CookieInformation.getConsentGivenFor("cookie_cat_statistic")
      ) {
        setCookieState(true);
      }

      window.addEventListener("CookieInformationConsentGiven", () => {
        if (
          globalThis.CookieInformation.getConsentGivenFor(
            "cookie_cat_marketing"
          ) &&
          globalThis.CookieInformation.getConsentGivenFor(
            "cookie_cat_statistic"
          )
        ) {
          setCookieState(true);
        }
      });
    } else {
      setCookieState(true);
    }
  }, []);
  */

  return (
    <Module>
      <Container variant={Use800PxRibbon ? "medium" : "small"}>
        {cookieState ? (
          <Box dangerouslySetInnerHTML={{ __html: EmbedCode }} />
        ) : (
          <Box className={styles.cookietext}>
            <Heading as="h2">{NoCookieHeading}</Heading>
            <Text dangerouslySetInnerHTML={{ __html: NoCookieText }}></Text>
          </Box>
        )}
      </Container>
    </Module>
  );
};

export { Embed };
